var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FileProcessor } from 'app/core/files/FileProcessor';
import { asyncImagePixelate } from 'app/image/pixelate/pixelate.async';
import { syncImagePixelate } from 'app/image/pixelate/pixelate.sync';
import { createImage } from 'app/stores/project/page';
import { hasOffscreenCanvas } from 'app/utils/caniuse';
import { Capabilities } from 'app/utils/Capabilities';
import { errorNotifier } from 'app/utils/error';
export const Cache = {
    vault: 'last-image',
    imageKey: '/last-image.dat',
    notesKey: '/last-notes.dat',
};
const Consts = {
    prefersSyncProcessor: false,
};
function isValidBlob(item) {
    return item && item instanceof Blob && item.size > 0;
}
export function loadImage(id, source) {
    return __awaiter(this, void 0, void 0, function* () {
        // errors
        const [, imageInfo] = yield FileProcessor.newInstance().process({
            file: source,
        });
        const { width, height, orientation } = imageInfo;
        const url = URL.createObjectURL(source);
        const pixelate = Consts.prefersSyncProcessor || !hasOffscreenCanvas()
            ? syncImagePixelate
            : asyncImagePixelate;
        let thumb;
        // NOTE: if might be smart to use thumbnail if available
        try {
            const pixelatedImage = yield pixelate(source, {
                width,
                height,
            }, {
                orientation,
                useBlur: configGet('pixelateUseBlur', false),
                isSafari: Capabilities.shared.isSafari,
            });
            if (!pixelatedImage) {
                return null;
            }
            console.log(pixelatedImage);
            const { bytes } = pixelatedImage;
            if (!isValidBlob(bytes)) {
                return null;
            }
            const blurredImageUrl = URL.createObjectURL(bytes);
            thumb = {
                width: pixelatedImage.width,
                height: pixelatedImage.height,
                url: blurredImageUrl,
            };
        }
        catch (error) {
            errorNotifier(error);
            throw error;
        }
        return createImage({
            id,
            size: { width, height },
            orientation: orientation,
            url,
            blurredImage: thumb,
        });
    });
}
